(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-hero-slideshow')) {
    class CSHeroSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.slides.length) return;
        this.index = 0;
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduce = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.reduce.matches;
        this.hovering = false;
        this.visible = true;
        this.editorHold = false;
        this.videoPaused = new Set();
        this.failed = new WeakSet();
        this.generation = 0;
        const listen = (target, name, fn, options = {}) => target.addEventListener(name, fn, { ...options, signal: this.abort.signal });
        this.querySelector('[data-navigation]')?.removeAttribute('hidden');
        listen(this, 'click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-prev')) this.go(this.index - 1, true);
          if (button.hasAttribute('data-next')) this.go(this.index + 1, true);
          if (button.hasAttribute('data-dot')) this.go(Number(button.dataset.dot), true);
          if (button.hasAttribute('data-autoplay-toggle')) {
            this.paused = !this.paused;
            this.updateRotation();
            this.schedule();
          }
          if (button.hasAttribute('data-video-toggle')) this.toggleVideo();
        });
        listen(this, 'keydown', event => {
          if (!event.target.closest('[data-navigation]') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this).direction === 'rtl';
          this.go(this.index + ((event.key === 'ArrowRight') !== rtl ? 1 : -1), true);
        });
        listen(this, 'focusin', () => {
          this.paused = true;
          this.updateRotation();
          this.schedule();
        });
        listen(this, 'mouseenter', () => {
          if (this.dataset.hover === 'true') { this.hovering = true; this.schedule(); }
        });
        listen(this, 'mouseleave', () => { this.hovering = false; this.schedule(); });
        listen(this, 'pointerdown', event => {
          if (event.pointerType === 'mouse' || event.target.closest('a,button')) return;
          this.touch = { x: event.clientX, y: event.clientY };
        }, { passive: true });
        listen(this, 'pointerup', event => {
          if (!this.touch) return;
          const dx = event.clientX - this.touch.x, dy = event.clientY - this.touch.y;
          this.touch = null;
          if (this.dataset.swipe === 'true' && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            const rtl = getComputedStyle(this).direction === 'rtl';
            this.go(this.index + ((dx < 0) !== rtl ? 1 : -1), true);
          }
        }, { passive: true });
        listen(this, 'pointercancel', () => { this.touch = null; });
        listen(document, 'visibilitychange', () => this.refresh());
        listen(this.mobile, 'change', () => this.refresh());
        listen(this.reduce, 'change', () => {
          if (this.reduce.matches) { this.paused = true; this.currentVideo?.pause(); }
          this.updateRotation(); this.refresh();
        });
        this.querySelectorAll('video').forEach(video => {
          video.muted = true;
          listen(video, 'loadeddata', () => video.classList.add('is-ready'));
          listen(video, 'playing', () => {
            this.failed.delete(video); video.classList.add('is-ready'); this.videoButton();
            if (this.dataset.videoEnd === 'true') this.schedule();
          });
          listen(video, 'pause', () => this.videoButton());
          listen(video, 'error', () => { this.failed.add(video); this.videoButton(); this.schedule(); });
          listen(video, 'ended', () => {
            this.videoButton();
            if (video === this.currentVideo && this.dataset.videoEnd === 'true' && this.canRotate()) this.go(this.index + 1);
          });
        });
        listen(document, 'shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorHold = true;
          this.go(index);
        });
        listen(document, 'shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
          this.editorHold = false;
          this.schedule();
        });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.refresh();
        }, { threshold: 0.05 });
        this.observer.observe(this);
        this.updateRotation();
        this.refresh();
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.generation++;
        this.querySelectorAll('video').forEach(video => video.pause());
        this.abort?.abort();
        this.observer?.disconnect();
        this.abort = null;
      }
      canRotate() {
        return this.slides.length > 1 && this.dataset.autoplay === 'true' && !this.paused && !this.hovering && !this.editorHold && this.visible && !document.hidden;
      }
      updateRotation() {
        const button = this.querySelector('[data-autoplay-toggle]');
        if (button) {
          button.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
          button.toggleAttribute('data-playing', !this.paused);
        }
        this.querySelector('.csh__stage').setAttribute('aria-live', this.paused ? 'polite' : 'off');
      }
      go(index, announce = false) {
        if (!this.slides.length) return;
        const next = (index + this.slides.length) % this.slides.length;
        if (announce) { this.paused = true; this.updateRotation(); }
        if (next !== this.index) {
          this.generation++;
          this.slides[this.index].querySelectorAll('video').forEach(video => { video.pause(); video.currentTime = 0; });
          this.slides.forEach((slide, i) => {
            slide.hidden = i !== next;
            slide.inert = i !== next;
            slide.setAttribute('aria-hidden', String(i !== next));
            slide.classList.toggle('is-entering', i === next);
          });
          this.index = next;
          this.dots.forEach((dot, i) => { if (i === next) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
          const counter = this.querySelector('[data-counter]');
          if (counter) counter.textContent = `${next + 1} / ${this.slides.length}`;
          if (announce) this.querySelector('[data-announcement]').textContent = this.dots[next]?.getAttribute('aria-label') || this.slides[next].getAttribute('aria-label');
        }
        this.refresh();
      }
      refresh() {
        const slide = this.slides[this.index];
        if (!slide) return;
        const desktop = slide.querySelector('.csh__video--desktop');
        const mobile = slide.querySelector('.csh__video--mobile');
        const current = this.mobile.matches ? (mobile || desktop) : (desktop || mobile);
        this.querySelectorAll('video').forEach(video => {
          const active = video === current;
          video.classList.toggle('is-current', active);
          if (!active) video.pause();
        });
        if (this.currentVideo !== current) this.generation++;
        this.currentVideo = current;
        const toggle = slide.querySelector('[data-video-toggle]');
        if (toggle) toggle.hidden = !current;
        if (current) {
          current.loop = slide.dataset.videoLoop === 'true' && !(this.dataset.autoplay === 'true' && this.dataset.videoEnd === 'true' && this.slides.length > 1);
          if (!this.visible || document.hidden || this.reduce.matches || this.videoPaused.has(slide)) current.pause();
          else if (slide.dataset.videoAutoplay === 'true' && current.paused && !current.ended) this.playVideo(current);
        }
        this.videoButton();
        this.schedule();
      }
      playVideo(video) {
        if (this.playingRequest === video) return;
        const generation = this.generation;
        this.playingRequest = video;
        const request = video.play();
        if (request) request.then(() => {
          if (!this.isConnected || generation !== this.generation || video !== this.currentVideo || !this.visible || document.hidden) video.pause();
        }).catch(() => {
          if (video === this.currentVideo) { this.failed.add(video); this.videoButton(); this.schedule(); }
        }).finally(() => { if (this.playingRequest === video) this.playingRequest = null; });
      }
      toggleVideo() {
        const video = this.currentVideo, slide = this.slides[this.index];
        if (!video) return;
        if (video.paused) { this.videoPaused.delete(slide); this.failed.delete(video); this.playVideo(video); }
        else { this.videoPaused.add(slide); video.pause(); this.schedule(); }
      }
      videoButton() {
        const button = this.slides[this.index]?.querySelector('[data-video-toggle]');
        if (!button || !this.currentVideo) return;
        const paused = this.currentVideo.paused;
        button.setAttribute('aria-label', paused ? this.dataset.videoPlayLabel : this.dataset.videoPauseLabel);
        button.toggleAttribute('data-playing', !paused);
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.canRotate()) return;
        const video = this.currentVideo;
        const wait = this.dataset.videoEnd === 'true' && video && !this.failed.has(video) && !video.paused && !video.ended;
        if (wait) return;
        const duration = Number(this.slides[this.index].dataset.duration) || Number(this.dataset.speed);
        this.timer = setTimeout(() => this.go(this.index + 1), duration);
      }
    }
    customElements.define('cs-hero-slideshow', CSHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joyful-faq-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      const sections = scope.matches && scope.matches('.jfaq') ? [scope] : scope.querySelectorAll('.jfaq');
      sections.forEach((section) => {
      if (section.dataset.jfaqInitialized === 'true') return;
      section.dataset.jfaqInitialized = 'true';
      const tabs = section.querySelectorAll('[data-jfaq-filter]');
      const groups = section.querySelectorAll('[data-jfaq-group]');
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const filter = tab.dataset.jfaqFilter;
          tabs.forEach((item) => {
            const active = item === tab;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
          groups.forEach((group) => {
            group.hidden = filter !== 'all' && group.dataset.jfaqGroup !== filter;
          });
        });
      });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joyful-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('joyful-header')) {
    class JoyfulHeader extends HTMLElement {
      connectedCallback() {
        this.menuDialog = this.querySelector('[data-jcs-menu-dialog]');
        this.searchDialog = this.querySelector('[data-jcs-search-dialog]');
        this.menuOpenButton = this.querySelector('[data-jcs-menu-open]');
        this.searchOpenButtons = Array.from(this.querySelectorAll('[data-jcs-search-open]'));

        this.menuOpenButton?.addEventListener('click', () => this.openDialog(this.menuDialog, this.menuOpenButton));
        this.querySelector('[data-jcs-menu-close]')?.addEventListener('click', () => this.menuDialog?.close());
        this.searchOpenButtons.forEach((button) => {
          button.addEventListener('click', () => {
            if (this.menuDialog?.open) this.menuDialog.close();
            this.openDialog(this.searchDialog, button);
            window.setTimeout(() => this.querySelector('[data-jcs-search-input]')?.focus(), 50);
          });
        });
        this.querySelector('[data-jcs-search-close]')?.addEventListener('click', () => this.searchDialog?.close());

        [this.menuDialog, this.searchDialog].forEach((dialog) => {
          if (!dialog) return;
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog && dialog === this.searchDialog) dialog.close();
          });
          dialog.addEventListener('close', () => this.handleDialogClose(dialog));
        });

        this.menuDialog?.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', () => this.menuDialog.close());
        });
      }

      openDialog(dialog, trigger) {
        if (!dialog) return;
        this.activeTrigger = trigger;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
        trigger?.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('jcs-header-dialog-open');
      }

      handleDialogClose(dialog) {
        if (dialog === this.menuDialog) this.menuOpenButton?.setAttribute('aria-expanded', 'false');
        if (dialog === this.searchDialog) this.searchOpenButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        if (!this.menuDialog?.open && !this.searchDialog?.open) document.documentElement.classList.remove('jcs-header-dialog-open');
        this.activeTrigger?.focus();
      }
    }

    customElements.define('joyful-header', JoyfulHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["joyful-story-timeline"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('joyful-story-timeline')) {
    class JoyfulStoryTimeline extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.tabs = Array.from(this.querySelectorAll('[data-jcs-story-tab]'));
        this.slides = Array.from(this.querySelectorAll('[data-jcs-story-slide]'));
        this.progress = this.querySelector('[data-jcs-story-progress]');
        this.navWrap = this.querySelector('[data-jcs-story-nav-wrap]');
        this.activeIndex = 0;
        this.autoplay = this.dataset.autoplay === 'true';
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.interval = Number(this.dataset.interval) || 7000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.style.setProperty('--jcs-story-year-count', this.tabs.length || 1);

        if (!this.tabs.length || !this.slides.length) return;

        this.handleClick = this.onClick.bind(this);
        this.handleKeydown = this.onKeydown.bind(this);
        this.handleMouseEnter = this.stopAutoplay.bind(this);
        this.handleMouseLeave = this.startAutoplay.bind(this);
        this.handleFocusIn = this.stopAutoplay.bind(this);
        this.handleFocusOut = this.onFocusOut.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('focusin', this.handleFocusIn);
        this.addEventListener('focusout', this.handleFocusOut);
        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', this.handleMouseEnter);
          this.addEventListener('mouseleave', this.handleMouseLeave);
        }
        document.addEventListener('shopify:block:select', this.handleBlockSelect);

        this.showSlide(0);
        this.startAutoplay();
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        if (!this.initialized) return;
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('focusin', this.handleFocusIn);
        this.removeEventListener('focusout', this.handleFocusOut);
        this.removeEventListener('mouseenter', this.handleMouseEnter);
        this.removeEventListener('mouseleave', this.handleMouseLeave);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }

      showSlide(index, focusTab = false) {
        this.activeIndex = (index + this.slides.length) % this.slides.length;

        this.tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === this.activeIndex;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focusTab) tab.focus();
        });

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.activeIndex;
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
        });

        if (this.progress) {
          const divisor = Math.max(this.slides.length - 1, 1);
          this.progress.style.setProperty('--jcs-story-progress', this.activeIndex / divisor);
        }

        this.centerActiveTab();
      }

      centerActiveTab() {
        if (!this.navWrap || this.navWrap.scrollWidth <= this.navWrap.clientWidth) return;
        const tab = this.tabs[this.activeIndex];
        const left = tab.offsetLeft - (this.navWrap.clientWidth - tab.offsetWidth) / 2;
        this.navWrap.scrollTo({ left: Math.max(0, left), behavior: this.reducedMotion ? 'auto' : 'smooth' });
      }

      startAutoplay() {
        if (!this.autoplay || this.reducedMotion || this.slides.length < 2) return;
        window.clearInterval(this.timer);
        this.timer = window.setInterval(() => this.showSlide(this.activeIndex + 1), this.interval);
      }

      stopAutoplay() {
        window.clearInterval(this.timer);
      }

      onClick(event) {
        const tab = event.target.closest('[data-jcs-story-tab]');
        const previous = event.target.closest('[data-jcs-story-prev]');
        const next = event.target.closest('[data-jcs-story-next]');

        if (tab) this.showSlide(Number(tab.dataset.index));
        if (previous) this.showSlide(this.activeIndex - 1);
        if (next) this.showSlide(this.activeIndex + 1);
        if (tab || previous || next) this.startAutoplay();
      }

      onKeydown(event) {
        const tab = event.target.closest('[data-jcs-story-tab]');
        if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.showSlide(0, true);
        if (event.key === 'End') this.showSlide(this.tabs.length - 1, true);
        if (event.key === 'ArrowLeft') this.showSlide(this.activeIndex - 1, true);
        if (event.key === 'ArrowRight') this.showSlide(this.activeIndex + 1, true);
        this.startAutoplay();
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this.startAutoplay();
      }

      onBlockSelect(event) {
        if (!event.detail || !event.detail.blockId) return;
        const selectedSlide = this.slides.find((slide) => slide.dataset.blockId === event.detail.blockId);
        if (!selectedSlide) return;
        this.stopAutoplay();
        this.showSlide(this.slides.indexOf(selectedSlide));
      }
    }

    customElements.define('joyful-story-timeline', JoyfulStoryTimeline);
  }

  } catch(e) { console.error(e); }
})();
})();
